<template>
  <div id="app" class="has-background-info-light">
    <Navbar />
    <div class="container">
      <router-view />
    </div>
  </div>
</template>

<script>
import Navbar from '@/components/Navbar.vue';

export default {
  components: {
    Navbar,
  },
  created() {
    document.title = 'Meštrovići';
  },
};
</script>

<style lang="scss"></style>
